import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import App from './App';
import './css.js';
import i18n from '../../i18n.js';
import { I18nextProvider } from 'react-i18next';
import reportWebVitals from '../../reportWebVitals.js';
import { ApolloClient, HttpLink, InMemoryCache, ApolloProvider, ApolloLink } from '@apollo/client';
import { ASTNode, stripIgnoredCharacters } from 'graphql';
import Loading from '../../components/Common/ui-components/Loading/index.js';
import { datadogRum } from '@datadog/browser-rum';
if (window.globalConfig.enableVConsole) {
    import('vconsole').then(({ default: VConsole }) => {
        new VConsole();
    });
}

sessionStorage.removeItem('__tmpRef'); //clear WA temp

const root = createRoot(document.getElementById('root'));

const link = new HttpLink({
    uri: window.globalConfig.GRAPHQL_URL,
    headers:{
        "Content-Type": "application/json"
    },
    useGETForQueries: window.globalConfig.QUERY_USE_GET_METHOD ? true : false,
    print(ast, originalPrint) {
        return stripIgnoredCharacters(originalPrint(ast));
    }
});
const linkStub = new HttpLink({
    uri: window.globalConfig.STUB_GRAPHQL_URL,
    headers:{
        "Content-Type": "application/json"
    },
    useGETForQueries: window.globalConfig.QUERY_USE_GET_METHOD ? true : false,
    print(ast, originalPrint) {
        return stripIgnoredCharacters(originalPrint(ast));
    }
});
const linkSiteCore = new HttpLink({
    uri: window.globalConfig.SITECORE_GRAPHQL_URL,
    headers: { sc_apikey: window.globalConfig.SITECORE_APIKEY },
    useGETForQueries: false
});

// const client = new ApolloClient({
//     link: link,
//     cache: new InMemoryCache({ addTypename: false })
// });

const client = new ApolloClient({
    link: ApolloLink.split(
        (operation) => operation.getContext().clientName === 'sitecore',
        linkSiteCore, //if above
        ApolloLink.split(
            (operation) => operation.getContext().clientName === 'wcas',
            linkStub, //if above
            link
        )
    ),
    cache: new InMemoryCache({ addTypename: false })
});

if (window.globalConfig.ENABLE_DATADOG) {
    datadogRum.init({
        ...window.globalConfig.DATADOG_RUM_CONFIG,
        site: 'datadoghq.com',
        version: window.globalConfig.VERSION.toLowerCase(), // datadog tags (version is a tag) doesn't support uppercase letters
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input'
    });

    // fetch(window.globalConfig.OTEL_URL); // kick start OTEL, fire and forget
}

root.render(
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <Suspense fallback={<Loading />}>
                <ApolloProvider client={client}>
                    <App />
                </ApolloProvider>
            </Suspense>
        </I18nextProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
